var __jsx = React.createElement;
import React from 'react';
var PriceDetailsShimmer = function PriceDetailsShimmer() {
  // Define a shimmer animation style
  var shimmerKeyframes = "\n    @keyframes shimmer {\n      0% { transform: translateX(-100%); }\n      100% { transform: translateX(100%); }\n    }\n  ";
  return /*#__PURE__*/React.createElement("div", {
    className: "bg-white rounded-lg border border-gray-100 p-4 w-full"
  }, /*#__PURE__*/React.createElement("style", null, shimmerKeyframes), /*#__PURE__*/React.createElement("div", {
    className: "mb-4 flex justify-start"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-32 h-6 bg-gray-100 rounded-md relative overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 bg-gradient-to-r from-transparent via-gray-200 to-transparent",
    style: {
      animation: 'shimmer 1.5s infinite linear'
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "w-full h-px bg-gray-100 mb-4"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-28 h-20 bg-gray-100 rounded-md relative overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 bg-gradient-to-r from-transparent via-gray-200 to-transparent",
    style: {
      animation: 'shimmer 1.5s infinite linear'
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-36 h-7 bg-gray-100 rounded-md relative overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 bg-gradient-to-r from-transparent via-gray-200 to-transparent",
    style: {
      animation: 'shimmer 1.5s infinite linear'
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "w-full h-px bg-gray-100 mb-4"
  }), /*#__PURE__*/React.createElement("div", {
    className: "mb-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center mb-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-24 h-6 bg-gray-100 rounded-md relative overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 bg-gradient-to-r from-transparent via-gray-200 to-transparent",
    style: {
      animation: 'shimmer 1.5s infinite linear'
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-32 h-6 bg-gray-100 rounded-md relative overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 bg-gradient-to-r from-transparent via-gray-200 to-transparent",
    style: {
      animation: 'shimmer 1.5s infinite linear'
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-start"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-48 h-4 bg-gray-50 rounded"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "mb-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center mb-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-28 h-6 bg-gray-100 rounded-md relative overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 bg-gradient-to-r from-transparent via-gray-200 to-transparent",
    style: {
      animation: 'shimmer 1.5s infinite linear'
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-48 h-6 bg-gray-100 rounded-md relative overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 bg-gradient-to-r from-transparent via-gray-200 to-transparent",
    style: {
      animation: 'shimmer 1.5s infinite linear'
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-start"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-64 h-4 bg-gray-50 rounded"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center mb-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-20 h-6 bg-gray-100 rounded-md relative overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 bg-gradient-to-r from-transparent via-gray-200 to-transparent",
    style: {
      animation: 'shimmer 1.5s infinite linear'
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-28 h-6 bg-gray-100 rounded-md relative overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 bg-gradient-to-r from-transparent via-gray-200 to-transparent",
    style: {
      animation: 'shimmer 1.5s infinite linear'
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center mb-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-16 h-6 bg-gray-100 rounded-md relative overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 bg-gradient-to-r from-transparent via-gray-200 to-transparent",
    style: {
      animation: 'shimmer 1.5s infinite linear'
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-32 h-6 bg-gray-100 rounded-md relative overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 bg-gradient-to-r from-transparent via-gray-200 to-transparent",
    style: {
      animation: 'shimmer 1.5s infinite linear'
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: "w-full h-px bg-gray-100 mb-5"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center mb-5"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-32 h-6 bg-gray-100 rounded-md relative overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 bg-gradient-to-r from-transparent via-gray-200 to-transparent",
    style: {
      animation: 'shimmer 1.5s infinite linear'
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-28 h-6 bg-gray-100 rounded-md relative overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 bg-gradient-to-r from-transparent via-gray-200 to-transparent",
    style: {
      animation: 'shimmer 1.5s infinite linear'
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "w-full h-px bg-gray-100 mb-5"
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex justify-between items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-32 h-6 bg-gray-100 rounded-md relative overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 bg-gradient-to-r from-transparent via-gray-200 to-transparent",
    style: {
      animation: 'shimmer 1.5s infinite linear'
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "w-24 h-6 bg-green-50 rounded-md relative overflow-hidden"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute inset-0 bg-gradient-to-r from-transparent via-green-100 to-transparent",
    style: {
      animation: 'shimmer 1.5s infinite linear'
    }
  }))));
};
export default PriceDetailsShimmer;